export const getFeatureFlags = (state) => state.featureFlags.flags;
